import axios from 'axios';
import { storage } from './storage';

// 백엔드 API URL — 환경변수 우선, 없으면 로컬 개발 서버
const rawUrl = process.env.REACT_APP_API_URL || 'https://api.azocsi.com';
// iOS ATS 호환을 위해 http://를 https://로 강제 변환 (localhost/127.0.0.1 제외)
const API_URL = rawUrl.includes('localhost') || rawUrl.includes('127.0.0.1')
  ? rawUrl
  : rawUrl.replace(/^http:\/\//, 'https://');
const BASE_URL = `${API_URL}/api`;

console.log('🔧 API_URL:', API_URL);
console.log('🔧 BASE_URL:', BASE_URL);

// Axios 인스턴스 생성
export const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: false,
});

// 요청 인터셉터 (JWT 토큰 자동 추가)
api.interceptors.request.use(
  (config) => {
    const token = storage.get('azocsii-token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 응답 인터셉터 (에러 처리)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // 토큰 만료 시 로그아웃 (로그인 페이지가 아닐 때만)
      const currentPath = window.location.pathname;
      if (currentPath !== '/login' && currentPath !== '/register') {
        storage.remove('azocsii-token');
        storage.remove('azocsii-user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
